export const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// based on https://gist.github.com/dperini/729294
export const URL_PATTERN = new RegExp(
  '^' +
    // protocol identifier (optional)
    // short syntax // still required
    '(?:(?:(?:https?):)?\\/\\/)' +
    '(?:www.|(?!www))' +
    '(?:' +
    // host & domain names, may end with dot
    '(?:' +
    '(?:' +
    '[a-z0-9\\u00a1-\\uffff]' +
    '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
    ')?' +
    '[a-z0-9\\u00a1-\\uffff]\\.' +
    ')+' +
    // TLD identifier name, may end with dot
    '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
    ')' +
    // port number (optional)
    '(?::\\d{2,5})?' +
    // resource path (optional)
    '(?:[/?#]\\S*)?' +
    '$',
  'i',
);

// example:
//  - valid: '0.1', '0,1', '0.50', '0,50', '2,00', '2.00', '2,00', '20,00', '20.00', '20,001', '20.001'
//  - invalid: '0.0', '0,0', '0.00', '0,00', '0.', '0,', '0'
export const NUMBER_WITH_SEPARATORS_PATTERN = /^(?!(0+$)|(0*(?:[,.\s])0+$))\d+(?:[,.\s]\d+)*$/;

export const SLUG_PATTERN = /^[a-zA-Z0-9-\s]*$/;
